import { IBaseAction } from '../../constants';

export interface AppInfoInitialState {
    version: string;
}
export const APP_INFO = 'APP_INFO';
export const APP_INFO_SUCCESS = 'APP_INFO_SUCCESS';
export interface GetAppInfoAction extends IBaseAction {
    type: typeof APP_INFO | typeof APP_INFO_SUCCESS;
    payload?: {
        data: AppInfoInitialState;
    };
}

export type ConditionType = { [key in string]: Array<string> };
export type ConditionList = { [key in string]: ConditionType };
export interface IamPolicyStatement {
    actions: Array<string>;
    effect: string;
    resource: string;
    conditions: ConditionList;
}

export const STRING_EQUALS = 'StringEquals';

export const DENIED = 'DENIED';
export const CONDITIONAL = 'CONDITIONAL';
export const ALLOWED = 'ALLOWED';

export const IAM_ACTION_EXIST = 'IAM_ACTION_EXIST';
export const IAM_ACTION_NOT_EXIST = 'IAM_ACTION_NOT_EXIST';
export const IAM_ACTION_ASTERISK_PATTERN = 'IAM_ACTION_ASTERISK_PATTERN';

export interface IamListInitialState {
    ALLOWED: Array<string>;
    CONDITIONAL: Array<string>;
    CONDITIONAL_STATEMENTS: Array<IamPolicyStatement>;
    DENIED: Array<string>;
}
export const IAM_LISTS = 'IAM_LISTS';
export const IAM_LISTS_SUCCESS = 'IAM_LISTS_SUCCESS';
export interface GetIamListsAction extends IBaseAction {
    type: typeof IAM_LISTS | typeof IAM_LISTS_SUCCESS;
    payload?: {
        data: IamListInitialState;
    };
}

//==========================================

//==========================================
//==========================================

//==========================================
export type AuthActionTypes = GetAppInfoAction | GetIamListsAction;
